import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatNumber, formatPercentage, getChangeIcon, getChangeColor } from '../utils/chartDataUtils';
import styles from '../styles/Team.module.css';

const MetricCard = ({ title, value, change, icon, color = 'blue', format = 'number', subtitle }) => {
  const formatValue = (val) => {
    if (format === 'percentage') return formatPercentage(val);
    if (format === 'number') return formatNumber(val);
    return val;
  };

  const getDisplayValue = () => {
    if (title === 'Your Rank') {
      return `#${value}`;
    }
    if (title === 'Total Earnings' || title === 'Biggest Win Today') {
      return `$${formatNumber(value)}`;
    }
    if (title === 'Commission Rate') {
      return `${value}%`;
    }
    return formatValue(value);
  };

  return (
    <div className={`${styles.metricCard} ${styles[`metricCard${color.charAt(0).toUpperCase() + color.slice(1)}`]}`}>
      <div className={styles.metricIcon}>
        {icon}
      </div>
      <div className={styles.metricContent}>
        <div className={styles.metricValue}>{getDisplayValue()}</div>
        <div className={styles.metricLabel}>{title}</div>
        {subtitle && <div className={styles.metricSubtitle}>{subtitle}</div>}
        {change !== undefined && typeof change === 'number' && (
          <div className={`${styles.metricChange} ${styles[getChangeColor(change)]}`}>
            <FontAwesomeIcon icon={getChangeIcon(change)} />
            <span>{Math.abs(change)}%</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard; 